import React from "react";
import PlansAndPricingHeroSection from "../components/PlansAndPricing/PlansAndPricingHeroSection";
import PricingArea from "../components/PricingArea";
import CtaArea from "../components/CtaArea";

const PlansAndPricing = ()=>{
    return(
        <>
        <PlansAndPricingHeroSection/>
        {/* <AboutUsBanner/> */}
        <PricingArea priceExcludesGst />
        <CtaArea/>

        </>
    )
}

export default PlansAndPricing;